import type { CheckoutAddress } from "@/app/(site)/contexts/Global"
import { USER_HAS_SELECTED_STATE_STORAGE_KEY } from "@/lib/siteconfig/constants"

/**
 * Sanitizes an address for storage
 * @param address - The address object to sanitize
 * @param includeCountry - Whether to include country (default: false). Set to true for billing address when sameShippingAddress is false
 * @returns Sanitized address, optionally including country, with state only if user has selected it, excluding apartmentHouseNumber
 */
export const sanitizeAddress = (
    address: CheckoutAddress | null | undefined,
    includeCountry: boolean = false
): CheckoutAddress | Omit<CheckoutAddress, "country" | "apartmentHouseNumber"> => {
    if (!address) return {}

    const {
        country,
        state,
        apartmentHouseNumber: _apartmentHouseNumber,
        ...rest
    } = address
    const userHasSelectedState =
        typeof window !== "undefined" &&
        sessionStorage.getItem(USER_HAS_SELECTED_STATE_STORAGE_KEY) === "true"

    const result: any = {
        ...rest,
        ...(userHasSelectedState ? { state: state || "" } : {})
    }

    // Include country if explicitly requested (for billing address when different from shipping)
    if (includeCountry && country) {
        result.country = country
    }

    return result
}
